import styled from "styled-components";

/* -------------------------------- Языковая панель -------------------------------- */
export const LenguageSwichWrapper = styled.div`
	position: relative;
	cursor: pointer;

	@media (max-width: 420px) {
		display: ${({ display }) => display || ""};
	}
`;

export const LenguageSwichText = styled.p`
	font-size: ${(p) => p.theme.fontSizes.fs14};
	margin-right: 4px;
`;

export const LengDropMenu = styled.ul`
	position: absolute;
	top: 25px;
	right: 16px;
	width: 22px;
	z-index: 999;

	> li {
		font-size: ${(p) => p.theme.fontSizes.fs14};
		cursor: pointer;
		transition: all 0.25s ease-out;
		&:hover,
		:focus {
			color: ${(p) => p.theme.colors.hoverText};
		}
	}
`;
